/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentEditorsCouponsQueryResponse,
  GetApiV1IndividualpaymentEditorsCouponsQueryParams,
  GetApiV1IndividualpaymentEditorsCoupons401,
  GetApiV1IndividualpaymentEditorsCoupons500,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentEditorsCoupons.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentEditorsCoupons } from "../../clients/individualPaymentEditorsController/getApiV1IndividualpaymentEditorsCoupons.ts";

export const getApiV1IndividualpaymentEditorsCouponsQueryKey = (
  params?: GetApiV1IndividualpaymentEditorsCouponsQueryParams,
) =>
  [
    { url: "/api/v1/individualpayment/editors/coupons" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1IndividualpaymentEditorsCouponsQueryKey = ReturnType<
  typeof getApiV1IndividualpaymentEditorsCouponsQueryKey
>;

export function getApiV1IndividualpaymentEditorsCouponsQueryOptions(
  params?: GetApiV1IndividualpaymentEditorsCouponsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1IndividualpaymentEditorsCouponsQueryKey(params);
  return queryOptions<
    GetApiV1IndividualpaymentEditorsCouponsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentEditorsCoupons401
      | GetApiV1IndividualpaymentEditorsCoupons500
    >,
    GetApiV1IndividualpaymentEditorsCouponsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentEditorsCoupons(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Filtra por descrição ou código; rótulo "Descrição - [x%]" ou "Descrição - [R$ x]". Migrado do legado CouponAsync/GetActiveCouponsDropDownList. **(Requer Authorization para autenticação)**
 * @summary Cupons ativos e vigentes (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/editors/coupons}
 */
export function useGetApiV1IndividualpaymentEditorsCoupons<
  TData = GetApiV1IndividualpaymentEditorsCouponsQueryResponse,
  TQueryData = GetApiV1IndividualpaymentEditorsCouponsQueryResponse,
  TQueryKey extends QueryKey = GetApiV1IndividualpaymentEditorsCouponsQueryKey,
>(
  params?: GetApiV1IndividualpaymentEditorsCouponsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentEditorsCouponsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentEditorsCoupons401
          | GetApiV1IndividualpaymentEditorsCoupons500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentEditorsCouponsQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentEditorsCouponsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentEditorsCoupons401
      | GetApiV1IndividualpaymentEditorsCoupons500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
